import { CenterAlignIcon, MiddleAlignIcon } from 'canoe';
import React, { useCallback } from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  alignItems?: string;
  alignSelf?: string;
  flexDirection?: string;
  toggleValues: (values: Record<string, unknown>) => void;
  isChild?: boolean;
}

export const AlignCenter = ({
  alignItems,
  alignSelf,
  flexDirection,
  toggleValues,
  isChild,
}: Props) => {
  const onClick = useCallback(() => {
    if (isChild) {
      toggleValues({
        alignSelf: 'center',
      });
    } else {
      toggleValues({
        alignItems: 'center',
      });
    }
  }, [isChild, toggleValues]);

  return (
    <ValueToggle
      toggleGroup={isChild ? 'self-align' : 'flex-align-items'}
      id={isChild ? 'self-align-center' : 'align-center'}
      data-cy="toolbox-flex-align-center"
      onClick={onClick}
      isActive={isChild ? alignSelf === 'center' : alignItems === 'center'}
      icon={flexDirection === 'row' ? MiddleAlignIcon : CenterAlignIcon}
      tooltip="Center"
      color="light"
    />
  );
};
